import React, { useCallback, useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import MenuItemCard from '../cards/menu _card';
import Modal from '@mui/material/Modal';
import '../lists/menu-list.scss';
import EmptyIcon from "@mui/icons-material/MenuOpenTwoTone";
import axios from '../../../../../../../../api/axios';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import 'react-datepicker/dist/react-datepicker.css';


function MenuItemList() {
  const business_entity_id = sessionStorage.getItem("configBizEntityId");
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [menuItems, setMenuItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [filterCategoryId, setFilterCategoryId] = useState('all');
  const [sections, setSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);
  const [filterSectionId, setFilterSectionId] = useState('all');
  const [kitchens, setKitchens] = useState([]);
  const [selectedKitchen, setSelectedKitchen] = useState('');

  const [openModal, setOpenModal] = useState(false);
  const [newItemName, setNewItemName] = useState('');
  const [newItemPrice, setNewItemPrice] = useState('');
  const [newItemCGST, setNewItemCGST] = useState('');
  const [newItemSGST, setNewItemSGST] = useState('');
  const [newItemCode, setNewItemCode] = useState('');
  const [menuCategoryDescription, setMenuCategoryDescription] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [editingItemId, setEditingItemId] = useState(null);
  const [isOpenItem, setIsOpenItem] = useState(false);
  const [startDate, setStartDate] = useState(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  });

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    const searchTimer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm.trim());
    }, 300);

    return () => clearTimeout(searchTimer);
  }, [searchTerm]);

  const fetchLookups = useCallback(async () => {
    try {
      const responseCategories = await axios.get(`businessEntities/getAllMenuCategories/${business_entity_id}`, {
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
      });
      setCategories(responseCategories.data.allCategories);

      const responseSections = await axios.get(`businessEntities/getAllSections/${business_entity_id}`, {
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
      });
      setSections(responseSections.data.allSections);

      const responseKitchens = await axios.get(`kitchenAndPrinters/kitchens/restaurant/${business_entity_id}`, {
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
      });
      setKitchens(Array.isArray(responseKitchens.data) ? responseKitchens.data : []);

    } catch (error) {
      console.error('Error fetching menu lookups:', error);
    }
  }, [business_entity_id]);

  useEffect(() => {
    if (business_entity_id) {
      fetchLookups();
    }
  }, [business_entity_id, fetchLookups]);

  useEffect(() => {
    if (business_entity_id) {
      fetchMenuItems();
    }
  }, [business_entity_id, debouncedSearchTerm, filterCategoryId, filterSectionId]);

  const fetchMenuItems = async () => {
    try {
      const responseMenuItems = await axios.get(`businessEntities/getAllMenuItems/${business_entity_id}`, {
        params: {
          search: debouncedSearchTerm || undefined,
          categoryId: filterCategoryId !== 'all' ? filterCategoryId : undefined,
          sectionId: filterSectionId !== 'all' ? filterSectionId : undefined,
        },
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
      });

      setMenuItems(responseMenuItems.data.allMenus);
    } catch (error) {
      console.error('Error fetching menu items:', error);
    }
  };


  const handleAddItem = () => {
    setNewItemName('');
    setNewItemPrice('');
    setNewItemCGST('');
    setNewItemSGST('');
    setNewItemCode('');
    setMenuCategoryDescription('');
    setSelectedCategory('');
    setSelectedSection('');
    setSelectedKitchen('');
    setEditingItemId(null);
    setOpenModal(true);
  };

  const handleEditItem = (item) => {
    setNewItemName(item.menu_name);
    setNewItemPrice(item.price);
    setNewItemCGST(item.cgst);
    setNewItemSGST(item.sgst);
    setNewItemCode(item.code);
    setMenuCategoryDescription(item.menu_category_description);
    setSelectedCategory(item.category_id);
    setSelectedSection(item.section_id ?? '');
    setSelectedKitchen(item.kitchen_id == null ? '' : String(item.kitchen_id));
    setEditingItemId(item.menu_id);
    setIsOpenItem(item.is_open_item === 0 ? false : true);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleItemSubmit = async () => {
    console.log('selectedCategory:', selectedCategory, 'type:', typeof selectedCategory);
    const missingFields = [];
    if (!newItemName) missingFields.push("Name");
    if (!newItemPrice) missingFields.push("Price");
    if (!newItemCGST) missingFields.push("CGST");
    if (!newItemSGST) missingFields.push("SGST");
    if (!selectedCategory || selectedCategory === "") missingFields.push("Category");
    
    if (missingFields.length > 0) {
      setSnackbarMessage(`Missing required field(s): ${missingFields.join(", ")}`);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      return;
    }


    const priceIsValid = !isNaN(newItemPrice) && Number(newItemPrice) >= 0;
    const cgstIsValid = !isNaN(newItemCGST) && Number(newItemCGST) >= 0;
    const sgstIsValid = !isNaN(newItemSGST) && Number(newItemSGST) >= 0;

    if (!priceIsValid || !cgstIsValid || !sgstIsValid) {
      setSnackbarMessage("Price, CGST, and SGST must be valid numbers.");
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      return;
    }

    try {
      const url = editingItemId
        ? 'businessEntities/updateMenuItems'
        : 'businessEntities/addMenuItem';

      const payload = {
        menuName: newItemName,
        cgst: newItemCGST,
        sgst: newItemSGST,
        code: newItemCode,
        menuCategoryDescription: menuCategoryDescription,
        is_open_item: isOpenItem ? 1 : 0,
        expires_on: isOpenItem
          ? startDate.toISOString().replace('T', ' ').slice(0, 19)
          : null,
        section: selectedSection ? parseInt(selectedSection, 10) : null,
        kitchen: selectedKitchen === '' ? null : Number(selectedKitchen),
        price: newItemPrice,
        menu_category_id: selectedCategory,
        businessEntityId: sessionStorage.getItem("configBizEntityId"),
      };




      if (editingItemId) {
        payload.menuId = editingItemId;
      }

      const response = await axios.post(url, payload, {
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
      });

      if (response.status === 200) {
        const successMessage = editingItemId ? "Menu item updated successfully!" : "Menu item added successfully!";
        setSnackbarMessage(successMessage);
        setSnackbarSeverity('success');
        setOpenSnackbar(true);
        setOpenModal(false);
        fetchMenuItems();
      }
      else if (response.status === 230) {
        const errorMessage = "The item code is already used by another menu item !";
        setSnackbarMessage(errorMessage);
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
        fetchMenuItems();
      }
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage(error.message);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };


  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (file.type !== 'text/csv') {
      setSnackbarMessage("Please upload a valid CSV file.");
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      return;
    }

    const maxFileSize = 5 * 1024 * 1024; //5 mb
    if (file.size > maxFileSize) {
      setSnackbarMessage("File size exceeds the maximum limit of 5MB.");
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('restaurant_id', sessionStorage.getItem("configBizEntityId"));
    const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
    if (userData.userId) {
      formData.append('user_id', userData.userId);
    }

    setIsUploading(true);

    try {
      const response = await axios.post(
        '/businessEntities/upload-menu-csv',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          withCredentials: false,
        }
      );

      const successMessage = response.data.message || "Menu CSV uploaded successfully!";
      fetchLookups();
      fetchMenuItems();

      setSnackbarMessage(successMessage);
      setSnackbarSeverity('success');
      setOpenSnackbar(true);

    } catch (error) {
      let errorMessage = 'Something went wrong with the menu CSV upload!';

      if (error.response) {
        errorMessage = error.response.data.error || `Error: ${error.response.statusText}`;
      } else if (error.request) {
        errorMessage = 'No response from the server. Please try again later.';
      } else {
        errorMessage = `Request error: ${error.message}`;
      }

      console.error('Error uploading CSV:', error);
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setIsUploading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const handleDelete = async (menu_id) => {
    try {
      const response = await axios.delete(`businessEntities/deleteMenuItem/${menu_id}`);

      if (response.status === 200) {
        fetchMenuItems();
        setSnackbarMessage("Item deleted successfully");
        setSnackbarSeverity('success');
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error deleting menu item:", error);
      setSnackbarMessage("Failed to delete menu item");
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  return (
    <div className="wrap">
      <div className="roww">
        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
          <p style={{ textDecoration: 'none', color: 'red' }}>
            Please ensure that the category name is spelled correctly when using the template. This will ensure proper linking; otherwise, a new category will be created.
          </p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <a href="/assets/templates/menu.csv" download="menu.csv" style={{ textDecoration: 'none' }}>
            Download CSV Template ?
          </a>
        </div>
        <div className="search">
          <input
            type="text"
            className="searchTerm"
            placeholder="Search items"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <select
            className="form-select"
            value={filterCategoryId}
            onChange={(e) => setFilterCategoryId(e.target.value)}
            style={{ maxWidth: '220px', marginRight: '10px' }}
          >
            <option value="all">All Categories</option>
            {categories.map((category) => (
              <option key={category.category_id} value={category.category_id}>
                {category.category_name}
              </option>
            ))}
          </select>
          <select
            className="form-select"
            value={filterSectionId}
            onChange={(e) => setFilterSectionId(e.target.value)}
            style={{ maxWidth: '220px', marginRight: '10px' }}
          >
            <option value="all">All Sections</option>
            {sections.map((section) => (
              <option key={section.section_id} value={section.section_id}>
                {section.section_name}
              </option>
            ))}
          </select>
          <Button
            variant="contained"
            onClick={handleAddItem}
            style={{ backgroundColor: '#4CAF50', color: 'white', marginRight: '10px' }}
          >
            Add Item
          </Button>

          <input
            type="file"
            accept=".csv"
            onChange={handleFileSelect}
            style={{ display: 'none' }}
            ref={fileInputRef}
          />
          <Button
            variant="contained"
            onClick={() => fileInputRef.current.click()}
            style={{ backgroundColor: '#2196F3', color: 'white', marginRight: '10px' }}
            disabled={isUploading}
          >
            {isUploading ? <CloudUploadIcon /> : "Upload CSV"}
          </Button>
        </div>
      </div>
      <div className="menu-container">
        <Grid container spacing={2} justifyContent="center">
          {menuItems.length > 0 ? (
            menuItems.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.menu_id}>
                <MenuItemCard item={item} onEdit={() => handleEditItem(item)} onDelete={() => handleDelete(item.menu_id)} />
              </Grid>
            ))
          ) : (
            <div className="empty-list">
              <EmptyIcon style={{ fontSize: 100 }} />
              <p>No items found</p>
            </div>
          )}
        </Grid>
      </div>

      <Modal open={openModal} onClose={handleCloseModal}>
        <div className="modal-container">
          <h4>{editingItemId ? "Edit Menu Item" : "Add Menu Item"}</h4>
          <form>
            <div className="form-group">
              <label>
                Name:
                <input
                  type="text"
                  value={newItemName}
                  onChange={(e) => setNewItemName(e.target.value)}
                  required
                  className="form-input"
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                Price:
                <input
                  type="number"
                  value={newItemPrice}
                  onChange={(e) => setNewItemPrice(e.target.value)}
                  required
                  className="form-input"
                />
              </label>
            </div>
            <div style={{ display: "flex", gap: "1rem" }}>

              <div className="form-group" style={{ flex: 1 }}>
                <label>
                  SGST:
                  <input
                    type="number"
                    value={newItemSGST}
                    onChange={(e) => setNewItemSGST(e.target.value)}
                    required
                    className="form-input"
                  />
                </label>
              </div>
              <div className="form-group" style={{ flex: 1 }}>
                <label>
                  CGST:
                  <input
                    type="number"
                    value={newItemCGST}
                    onChange={(e) => setNewItemCGST(e.target.value)}
                    required
                    className="form-input"
                  />
                </label>
              </div>
            </div>


            <div className="form-group">
              <label>
                Category:
                <select
                  value={selectedCategory}
                  onChange={(e) => {
                    console.log('Category selected:', e.target.value);
                    setSelectedCategory(e.target.value);
                  }}
                  required
                  className="form-select"
                >
                  <option value="" disabled>Select a category</option>
                  {categories.map((category) => (
                    <option key={category.category_id} value={category.category_id}>
                      {category.category_name}
                    </option>
                  ))}
                </select>

              </label>
            </div>

            <div className="form-group">
              <label>
                Kitchen:
                <select
                  value={kitchens.length > 0 ? selectedKitchen : ''}
                  onChange={(e) => setSelectedKitchen(e.target.value)}
                  className="form-select"
                  disabled={kitchens.length === 0}
                  required={kitchens.length > 0}
                >
                  {kitchens.length === 0 ? (
                    <option value="" disabled>No kitchen found</option>
                  ) : (
                    <>
                      <option value="" disabled>Select a kitchen</option>
                      {kitchens.map((kitchen) => (
                        <option key={kitchen.id} value={kitchen.id}>
                          {kitchen.name}
                        </option>
                      ))}
                    </>
                  )}
                </select>

              </label>
            </div>

            <div className="form-group">
              <label>
                Item Code(Optional):
                <input
                  type="text"
                  value={newItemCode}
                  onChange={(e) => (e.target.value.length > 0) ? setNewItemCode(e.target.value) : null}
                  required
                  className="form-input"
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                Cuisine(Optional):
                <input
                  type="text"
                  value={menuCategoryDescription}
                  onChange={(e) => (e.target.value.length > 0) ? setMenuCategoryDescription(e.target.value) : null}
                  required
                  className="form-input"
                />
              </label>
            </div>
            <div className="formInput">
              <label>Section(Optional):</label>
              <select className="dropdown" value={selectedSection} onChange={(e) => setSelectedSection(e.target.value)}>
                <option value="">Select a section</option>
                {sections.map(e => (
                  <option key={e.section_id} value={e.section_id}>
                    {e.section_name}
                  </option>
                ))}
              </select>
            </div>
            {/* <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input
                type="checkbox"
                id="openItemCheckbox"
                checked={isOpenItem}
                onChange={(e) => setIsOpenItem(e.target.checked)}
                style={{ cursor: 'pointer' }}
              />
              <label htmlFor="openItemCheckbox" style={{ cursor: 'pointer' }}>
                Open Item
              </label>
            </div>

            {isOpenItem && (
              <div style={{ marginTop: '15px', padding: '10px', border: '1px solid #e0e0e0', borderRadius: '8px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#333' }}>
                  Expires On:
                </label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  dateFormat="MMMM d, yyyy"
                  minDate={new Date()}
                  showYearDropdown
                  dropdownMode="select"
                  wrapperStyle={{
                    display: 'inline-block',
                    margin: '5px 0',
                    width: '100%'
                  }}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #4a90e2',
                    borderRadius: '6px',
                    fontSize: '16px',
                    color: '#333',
                    backgroundColor: '#f8f9fa'
                  }}
                />
                <p style={{
                  marginTop: '10px',
                  fontSize: '14px',
                  color: '#666',
                  fontWeight: '500'
                }}>
                  Selected Date: {startDate.toDateString()}
                </p>
              </div>
            )} */}



            <div className="modal-actions">
              <Button variant="contained" color="primary" onClick={handleItemSubmit}>
                {editingItemId ? "Update" : "Add"}
              </Button>
              <Button variant="contained" onClick={handleCloseModal}>
                Cancel
              </Button>
            </div>
          </form>
        </div>
      </Modal>


      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <MuiAlert elevation={6} severity={snackbarSeverity} onClose={handleSnackbarClose}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default MenuItemList;
